module.exports = __webpack_public_path__ + "static/img/06.ef7d654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/06.png
// module id = 4DHo
// module chunks = 1